"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeURLParameter = exports.isRealValue = exports.getMMDomainUrl = exports.getCookieValue = exports.getCookieJson = exports.getComponentContentId = exports.extractFieldsFn = exports.columnWidth = exports.appendSlashPrefixIfNeeded = exports.addOrUpdateUrlParam = void 0;
var _lodash = require("lodash");
var _globalDataContext = _interopRequireDefault(require("../lib/globalDataContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Returns Object containing Sitecore fields
 *
 * @param {*} props Sitecore Link Field JSON response
 *
 * @returns {object} Containing JSON for Sitecore fields
 */
var extractFieldsFn = props => (0, _lodash.get)(props, 'rendering.fields');
/**
 * Returns the number of elements returned from array
 *
 * @param {*} props Sitecore # of array response
 * @param {*} cols Sitecore # of cols
 * @returns {string} Element width in columns (1/12)
 */
exports.extractFieldsFn = extractFieldsFn;
var columnWidth = (props, cols) => [1, 2, 3, 4].indexOf(props) > -1 ? 12 / parseInt(props) : cols;

/**
 * Function to read the cookies from the browser
 *
 * @param {string} key Key-Name of the cookie
 * @returns {string} AMC Logout url per environment
 */
exports.columnWidth = columnWidth;
var getCookieValue = key => {
  if (typeof Element === 'undefined') {
    return;
  }
  var re = new RegExp(key + '=([^;]+)');
  var value = re.exec(document.cookie);
  return value !== null ? unescape(value[1]) : null;
};

/**
 * Function to create a JSON from Cookie value
 *
 * @param {string} cookieValues Key-Name of the cookie
 * @param {string} useCamelCase to convert the keys into camelCase
 * @returns {JSON} JSON with values
 */
exports.getCookieValue = getCookieValue;
var getCookieJson = exports.getCookieJson = function getCookieJson(cookieValues) {
  var useCamelCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var cookieValue = getCookieValue(cookieValues);
  if ((0, _lodash.isNull)(cookieValue)) {
    return null;
  }
  var utmsArray = (0, _lodash.split)(cookieValue, '&');
  return (0, _lodash.reduce)(utmsArray, (result, value, key) => {
    var utmSplit = value.split('=');
    useCamelCase ? result[(0, _lodash.camelCase)(utmSplit[0])] = utmSplit[1] : result[utmSplit[0]] = utmSplit[1];
    return result;
  }, {});
};

/**
 * Returns Web content api URL
 *
 * @param {*} url relative Url
 * @param {*} useMMComHomeDomain if url should be with mmcom homepage
 * @param {*} previewEnvUnavailable if live preview not available
 * @param {*} caseSensitive url is case sensitive
 *
 * @returns {string} relative or abosulte mm com url per environment
 */
var getMMDomainUrl = exports.getMMDomainUrl = function getMMDomainUrl(url) {
  var useMMComHomeDomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var previewEnvUnavailable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var caseSensitive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var returnUrl = url;
  url = appendSlashPrefixIfNeeded(url);
  if (useMMComHomeDomain) {
    returnUrl = _globalDataContext.default.env == 'preview' && previewEnvUnavailable ? 'https://www.massmutual.com' + url : _globalDataContext.default.mmcomDomain + url;
  } else {
    returnUrl = _globalDataContext.default.appDomain + url;
  }
  return caseSensitive ? returnUrl : returnUrl.toLowerCase();
};

/**
 * Returns relative / prefixed url
 *
 * @param {*} url relative url
 *
 * @returns {string} relative / prefixed url
 */
var appendSlashPrefixIfNeeded = url => {
  if (!(0, _lodash.isEmpty)(url)) url = url.slice(0, 1) === '/' ? url : '/' + url;
  return url;
};

/**
 * Returns url with passed parameter updated or added.
 *
 * @param {*} url page url with querystring
 * @param {*} name name of parameter
 * @param {*} value value of parameter
 *
 * @returns {string} updated url
 */
exports.appendSlashPrefixIfNeeded = appendSlashPrefixIfNeeded;
var addOrUpdateUrlParam = (url, name, value) => {
  var href = url.toLowerCase();
  var regex = new RegExp('[&\\?]' + name + '=');
  if (regex.test(href)) {
    regex = new RegExp('([&\\?])' + name + '=\\d+');
    if (value === '') return href.split('?')[0];else return href.replace(regex, '$1' + name + '=' + value);
  } else {
    if (href.indexOf('?') > -1) return href + '&' + name + '=' + value;else return href + '?' + name + '=' + value;
  }
};

/**
 * Returns url with parameter removed
 *
 * @param {*} url url to work with
 * @param {*} parameter parameter to remove
 *
 * @returns {string} updated url
 */
exports.addOrUpdateUrlParam = addOrUpdateUrlParam;
var removeURLParameter = (url, parameter) => {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.toLowerCase().split('?');
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + '=';
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }
    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url.toLowerCase();
};
exports.removeURLParameter = removeURLParameter;
var getComponentContentId = contentDataSourceId => {
  if ((0, _lodash.isEmpty)(contentDataSourceId)) return '';else if (contentDataSourceId.substring(0, 1) === '{') return contentDataSourceId.slice(1, -1);else return contentDataSourceId.toUpperCase();
};
exports.getComponentContentId = getComponentContentId;
var isRealValue = obj => {
  return obj && obj !== 'null' && obj !== 'undefined';
};
exports.isRealValue = isRealValue;